enum HomeDeliveryAvailabilityEnum {
	available = 'available',
	unavailable = 'unavailable',
	notInRange = 'notInRange',
	notSoldTemp = 'notSoldTemp',
	mixed = 'mixed'
}
export default HomeDeliveryAvailabilityEnum;
